export default __webpack_public_path__ + "static/media/bill-success.a856628e.svg";